/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * inojin-stg-api
 * OpenAPI spec version: 1.0.0
 */

/**
 * authorized: オーソリ処理済み（旧スキーム互換、新規発行なし）
inBilling: 決済処理中
done: 決済完了
canceled: 決済キャンセル
failed: 決済失敗
reOrder: 診察ステータス完了後に再精算が必要
pendingAuthentication: 3DS 認証待ち（requires_action）

 */
export type OrderModelDTOStatus = typeof OrderModelDTOStatus[keyof typeof OrderModelDTOStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrderModelDTOStatus = {
  authorized: 'authorized',
  inBilling: 'inBilling',
  done: 'done',
  canceled: 'canceled',
  failed: 'failed',
  reOrder: 'reOrder',
  pendingAuthentication: 'pendingAuthentication',
} as const;
